import React from 'react';
import { SuggestionStats } from './Models';

interface Props {
    stats: SuggestionStats;
    openCreate: () => void;
    openMain: () => void;
    showBack: boolean;
    showCreate: boolean;
}

const Header: React.FC<Props> = (props) => {
    return (
        <div className="suggestions-header">
            {props.showBack && <div className="icon" onClick={() => props.openMain()}>
                <svg style={({ width: '24px', height: '24px' })} viewBox="0 0 24 24">
                    <path fill="#000000" d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
                </svg>
            </div>}
            <div className="suggestions-header__title"><div className="suggest-mainicon"></div>Suggestions</div>
            <div className="suggestions-header__status">{props.stats.open} open | {props.stats.completed} completed | {props.stats.rejected} rejected</div>
            <div className="suggestions-header__spacer"></div>
            {props.showCreate && <button className="suggestions-header__action button button--blue" onClick={() => props.openCreate()}>
                <span>Create</span>
                <div className="icon">
                    <svg viewBox="0 0 24 24">
                        <path fill="#000000" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
                    </svg>
                </div>
            </button>}
        </div>);
};
export default Header;